import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-do-range',
  templateUrl: './do-range.component.html',
  styleUrls: [],
  standalone: false
})
export class DoRangeComponent {
  @Input() from: any = null;
  @Input() to: any = null;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor() {}
}
